import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import DHeader from "./components/DHeader";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import Home from "./pages/Home";

function App() {
    return (
        <BrowserRouter>
            <DHeader />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
